export enum LicensePlateType {
    Standard = "LICENSE_PLATE_CAR_STANDARD",
    Personalized = "LICENSE_PLATE_CAR_PERSONALIZED"
}
